import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Connect from './Connect';
import * as serviceWorker from './serviceWorker';

const element = document.getElementById('root');
const connect = document.getElementById('chat-connect');
if (element !== null) {
  const {
    sb_id,
    sb_user,
    sb_token,
    available_language,
    language,
    room,
    portal_token,
    user_kind,
    portal_id,
  } = element.dataset;
  ReactDOM.render(
    <App
      sb_id={sb_id}
      sb_user={sb_user}
      sb_token={sb_token}
      available_language={available_language}
      language={language}
      room={room}
      portal_token={portal_token}
      portal_id={portal_id}
      user_kind={user_kind}
    />,
    element,
  );
}

if (connect !== null) {
  const { sb_id, sb_user, sb_token, available_language, language, room } = connect.dataset;
  ReactDOM.render(
    <Connect
      sb_id={sb_id}
      sb_user={sb_user}
      sb_token={sb_token}
      available_language={available_language}
      language={language}
      room={room}
    />,
    connect,
  );
}

serviceWorker.unregister();
